import { FunctionComponent, ReactElement, ReactNode } from 'react';
import './auth-layout.scss';

const AuthLayout: FunctionComponent<{ children: ReactNode }> = ({ children }): ReactElement => (
	<div className="auth">
		<div className="auth-container">{children}</div>
	</div>
);

export default AuthLayout;
